import { ReactNode } from 'react';
import store from '../../../utils/store';

export function generateNotificationId(message?: ReactNode): string {
    const appState = store.getState().app;
    if (message && appState && appState.appConfig) {
        const duplicate = appState.appConfig.DUPLICATE_NOTIFICATION ?? true;
        if (!duplicate) {
            const messageReactElement = message as React.ReactElement;
            if (messageReactElement.props && messageReactElement.props.id) {
                return messageReactElement.props.id;
            }
        }
    }
    return `${Date.now()}-${Math.floor(Math.random() * 100)}`;
}
